import { SimpleChanges, TemplateRef } from '@angular/core';
import { ActionPlanItem } from '../../../../shared/model/action-plan-item.model';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '../../../message/message.service';
import { ActionPlanItemService } from '../../../action-plan-item/action-plan-item.service';
import { BaseComponent } from '../../../../shared/base.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionStorageService } from 'ngx-webstorage';
import { JhiAlertService } from '../../../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../../../action-plan-item/action-plan-item.service";
import * as i2 from "../../../message/message.service";
import * as i3 from "@ngx-translate/core";
import * as i4 from "ngx-webstorage";
import * as i5 from "../../../../ng-jhipster/service";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
import * as i7 from "@angular/common";
import * as i8 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i9 from "@angular/forms";
import * as i10 from "../../../../shared/auto-direction-switch/input-auto-direction-switch.directive";
import * as i11 from "@angular/material/checkbox";
import * as i12 from "../../../../shared/alert/alert-error.component";
import * as i13 from "@fortawesome/angular-fontawesome";
function ActionPlanFormPartComponent_h5_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h5", 17);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("jhiTranslate", ctx_r0.headerKey);
} }
function ActionPlanFormPartComponent__svg_use_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 18);
} }
function ActionPlanFormPartComponent__svg_use_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 19);
} }
function ActionPlanFormPartComponent_div_13_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "mat-checkbox", 30);
    i0.ɵɵlistener("ngModelChange", function ActionPlanFormPartComponent_div_13_div_3_Template_mat_checkbox_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r13); const i_r8 = i0.ɵɵnextContext().index; const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.actionPlanItems[i_r8].status = $event; })("change", function ActionPlanFormPartComponent_div_13_div_3_Template_mat_checkbox_change_1_listener() { i0.ɵɵrestoreView(_r13); const i_r8 = i0.ɵɵnextContext().index; const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.saveOrUpdateItem(i_r8); })("mousedown", function ActionPlanFormPartComponent_div_13_div_3_Template_mat_checkbox_mousedown_1_listener() { i0.ɵɵrestoreView(_r13); const i_r8 = i0.ɵɵnextContext().index; const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.onMouseDown(i_r8); })("mouseup", function ActionPlanFormPartComponent_div_13_div_3_Template_mat_checkbox_mouseup_1_listener() { i0.ɵɵrestoreView(_r13); const i_r8 = i0.ɵɵnextContext().index; const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.onMouseUp(i_r8); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    const t_r7 = ctx_r21.$implicit;
    const i_r8 = ctx_r21.index;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r9.disabled)("checked", t_r7.status)("ngModel", ctx_r9.actionPlanItems[i_r8].status);
} }
function ActionPlanFormPartComponent_div_13_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "button", 32);
    i0.ɵɵlistener("click", function ActionPlanFormPartComponent_div_13_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(); const t_r7 = ctx_r24.$implicit; const i_r8 = ctx_r24.index; const ctx_r22 = i0.ɵɵnextContext(); const _r5 = i0.ɵɵreference(18); return ctx_r22.confirmDeleteActionPlanItem(_r5, t_r7, i_r8); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 33);
    i0.ɵɵelement(3, "use", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r11.disabled);
} }
const _c0 = function (a0) { return { "height": a0 }; };
function ActionPlanFormPartComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtemplate(3, ActionPlanFormPartComponent_div_13_div_3_Template, 2, 3, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 23);
    i0.ɵɵelementStart(5, "textarea", 24, 25);
    i0.ɵɵlistener("ngModelChange", function ActionPlanFormPartComponent_div_13_Template_textarea_ngModelChange_5_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r26); const i_r8 = restoredCtx.index; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.actionPlanItems[i_r8].itemText = $event; })("blur", function ActionPlanFormPartComponent_div_13_Template_textarea_blur_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r26); const i_r8 = restoredCtx.index; const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.saveOrUpdateItem(i_r8); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 26);
    i0.ɵɵelementStart(8, "small", 27);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, ActionPlanFormPartComponent_div_13_div_10_Template, 4, 1, "div", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r8 = ctx.index;
    const _r10 = i0.ɵɵreference(6);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.isSelectable());
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("maxlength", ctx_r3.charLimit);
    i0.ɵɵproperty("disabled", ctx_r3.disabled)("ngModel", ctx_r3.actionPlanItems[i_r8].itemText)("ngStyle", i0.ɵɵpureFunction1(9, _c0, ctx_r3.textAreaHeight(_r10)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r3.actionPlanItems[i_r8].itemText.length < ctx_r3.charLimit ? "text-success" : "text-danger");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r3.actionPlanItems[i_r8].itemText.length, "/", ctx_r3.charLimit, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.multipleItemsAllowed());
} }
function ActionPlanFormPartComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "button", 36);
    i0.ɵɵlistener("click", function ActionPlanFormPartComponent_div_14_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.addTextBox(); });
    i0.ɵɵtext(2, " + Add more ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("d-none", ctx_r4.collapsed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r4.disabled);
} }
function ActionPlanFormPartComponent_ng_template_17_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵelement(2, "h4", 39);
    i0.ɵɵelementStart(3, "button", 40);
    i0.ɵɵlistener("click", function ActionPlanFormPartComponent_ng_template_17_div_0_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.dismissAll(); });
    i0.ɵɵtext(4, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 41);
    i0.ɵɵelement(6, "jhi-alert-error");
    i0.ɵɵelement(7, "p", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 43);
    i0.ɵɵelementStart(9, "button", 44);
    i0.ɵɵlistener("click", function ActionPlanFormPartComponent_ng_template_17_div_0_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.dismissAll(); });
    i0.ɵɵelement(10, "fa-icon", 45);
    i0.ɵɵtext(11, "\u00A0 ");
    i0.ɵɵelement(12, "span", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 47);
    i0.ɵɵlistener("click", function ActionPlanFormPartComponent_ng_template_17_div_0_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r34); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.deleteActionPlanItem(); });
    i0.ɵɵelement(14, "fa-icon", 48);
    i0.ɵɵtext(15, "\u00A0 ");
    i0.ɵɵelement(16, "span", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ActionPlanFormPartComponent_ng_template_17_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 38);
    i0.ɵɵelementStart(2, "h4", 50);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 40);
    i0.ɵɵlistener("click", function ActionPlanFormPartComponent_ng_template_17_div_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r39); const modal_r30 = i0.ɵɵnextContext().$implicit; return modal_r30.dismiss("cancel click"); });
    i0.ɵɵtext(6, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 41);
    i0.ɵɵelement(8, "jhi-alert-error");
    i0.ɵɵelementStart(9, "p");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 43);
    i0.ɵɵelementStart(13, "button", 44);
    i0.ɵɵlistener("click", function ActionPlanFormPartComponent_ng_template_17_div_1_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r39); const modal_r30 = i0.ɵɵnextContext().$implicit; return modal_r30.dismiss("cancel click"); });
    i0.ɵɵelement(14, "fa-icon", 51);
    i0.ɵɵtext(15, "\u00A0 ");
    i0.ɵɵelementStart(16, "span");
    i0.ɵɵtext(17, "OK");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "sessionChat.messages.title"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 4, "sessionChat.messages.deletedActionItem"));
} }
function ActionPlanFormPartComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ActionPlanFormPartComponent_ng_template_17_div_0_Template, 17, 0, "div", 37);
    i0.ɵɵtemplate(1, ActionPlanFormPartComponent_ng_template_17_div_1_Template, 18, 6, "div", 37);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r6.actionPlanItemDeletedFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.actionPlanItemDeletedFlag);
} }
export class ActionPlanFormPartComponent extends BaseComponent {
    constructor(actionPlanItemService, messageService, translateService, sessionStorage, alertService, modalService) {
        super(sessionStorage, modalService);
        this.actionPlanItemService = actionPlanItemService;
        this.messageService = messageService;
        this.translateService = translateService;
        this.sessionStorage = sessionStorage;
        this.alertService = alertService;
        this.modalService = modalService;
        this.headerKey = '';
        this.actionPlanItemDeletedFlag = false;
        this.charLimit = 140;
        this.savingIndex = -1;
    }
    ngOnInit() {
        this.headerKey = 'inukaNgApp.ActionPlanGroup.' + this.actionPlanGroup.toString();
        if (this.actionPlanGroup.toString() === "THE_CHANGE_I_WANT_TO_SEE" /* THE_CHANGE_I_WANT_TO_SEE */.toString()) {
            this.charLimit = 250;
        }
    }
    ngOnChanges(changes) {
        this.initActionPlanGroupIfRequired();
    }
    initActionPlanGroupIfRequired() {
        if (this.actionPlanItems.length === 0) {
            this.actionPlanItems.push(new ActionPlanItem(null, this.actionPlanGroup, '', false, this.actionPlan, false));
        }
        else {
            // console.log('length: ' + this.actionPlanItems.length);
        }
    }
    addTextBox() {
        let x = new ActionPlanItem(null, this.actionPlanGroup, '', false, this.actionPlan, false);
        this.actionPlanItems.push(x);
    }
    saveOrUpdateItem(i) {
        if (this.mouseDown && this.savingIndex === i) {
            console.log('mouse is down, do not save');
            return;
        }
        const iActionPlanItem = this.actionPlanItems[i];
        iActionPlanItem.status = this.actionPlanItems[i].status;
        this.saveOrUpdateInner(iActionPlanItem, i);
    }
    saveOrUpdateInner(item, i) {
        this.savingIndex = i;
        console.log(item);
        if (item.id === null) {
            const actionGroupItems = this.actionPlanItems.filter(x => x.id && x.actionPlanGroup === item.actionPlanGroup);
            if (actionGroupItems && actionGroupItems.length) {
                item.sort = actionGroupItems[actionGroupItems.length - 1].sort + 1; // plus 1 to sort number of the last item in that group
            }
            if (!item.sort) {
                item.sort = 1;
            }
            this.observable = this.actionPlanItemService.create(item);
        }
        else {
            this.observable = this.actionPlanItemService.update(item);
        }
        this.observable.subscribe((res) => {
            console.log('saved action plan item ' + i);
            this.actionPlanItems[i] = res.body;
        });
    }
    onMouseDown(i) {
        this.mouseDown = true;
        this.savingIndex = i;
    }
    onMouseUp(i) {
        this.mouseDown = false;
        this.savingIndex = -1;
    }
    sharePlan(actionPlanItems, actionPlanGroup) {
        let list = '', styledText = '';
        if (actionPlanGroup === "THE_CHANGE_I_WANT_TO_SEE") {
            for (let i = 0; i < actionPlanItems.length; i++) {
                const item = actionPlanItems[i];
                styledText = item.status ? '<b>' + item.itemText + '</b>' : item.itemText;
                list += `<span>${styledText}</span>`;
            }
        }
        else {
            for (let i = 0; i < actionPlanItems.length; i++) {
                const item = actionPlanItems[i];
                styledText = item.status ? '<b>' + item.itemText + '</b>' : item.itemText;
                list += `<li>${styledText}</li>`;
            }
        }
        let translateKey = `inukaNgApp.ActionPlanGroup.${actionPlanGroup}`;
        const translateValue = this.translateService.instant(translateKey);
        let html = `
      <div id="action-plan-group">
        <h4 class="text-center" jhiTranslate="${translateValue}">${translateValue}</h4>
        <ol class="text-left">${list}</ol>
      </div>`;
        // console.log(html);
        let request = {
            message: html,
            sessionId: this.session.id,
            notifyWellbeingPlanUpdated: true,
            actionPlanId: this.actionPlan.id,
            actionPlanGroup
        };
        this.messageService.shareWellbeingPlan(request).subscribe(() => this.alertService.info('inukaNgApp.session.hasBeenSent', { param: translateValue }), () => console.log('fail'));
    }
    confirmDeleteActionPlanItem(content, actionPlanItem, index) {
        this.actionPlanItemDeletedFlag = false;
        this.actionPlanItemBeingProcessed = actionPlanItem;
        this.actionPlanItemBeingProcessedIndex = index;
        this.open(content);
    }
    deleteActionPlanItem() {
        // console.log('deleteActionPlanItem');
        if (this.actionPlanItemBeingProcessed.id) {
            this.actionPlanItemService.delete(this.actionPlanItemBeingProcessed.id).subscribe(() => {
                this.actionPlanItemDeletedFlag = true;
            });
        }
        else {
            this.actionPlanItemDeletedFlag = true;
        }
        this.actionPlanItems.splice(this.actionPlanItemBeingProcessedIndex, 1);
        this.initActionPlanGroupIfRequired();
    }
    textAreaHeight(e) {
        // console.log(this.constructor.name + ": textAreaHeight");
        return e.scrollHeight + (e.offsetHeight - e.clientHeight) + 'px';
    }
    multipleItemsAllowed() {
        return this.actionPlanGroup.toString() !== "THE_CHANGE_I_WANT_TO_SEE" /* THE_CHANGE_I_WANT_TO_SEE */.toString();
    }
    isSelectable() {
        const apg = this.actionPlanGroup.toString();
        return apg !== "THE_CHANGE_I_WANT_TO_SEE" /* THE_CHANGE_I_WANT_TO_SEE */.toString() && apg !== "STEPS_I_WILL_TAKE" /* STEPS_I_WILL_TAKE */.toString();
    }
    toggleCollapse() {
        this.collapsed = !this.collapsed;
    }
}
ActionPlanFormPartComponent.ɵfac = function ActionPlanFormPartComponent_Factory(t) { return new (t || ActionPlanFormPartComponent)(i0.ɵɵdirectiveInject(i1.ActionPlanItemService), i0.ɵɵdirectiveInject(i2.MessageService), i0.ɵɵdirectiveInject(i3.TranslateService), i0.ɵɵdirectiveInject(i4.SessionStorageService), i0.ɵɵdirectiveInject(i5.JhiAlertService), i0.ɵɵdirectiveInject(i6.NgbModal)); };
ActionPlanFormPartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ActionPlanFormPartComponent, selectors: [["action-plan-form-part"]], inputs: { session: "session", actionPlan: "actionPlan", actionPlanItems: "actionPlanItems", actionPlanGroup: "actionPlanGroup", disabled: "disabled" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 19, vars: 8, consts: [["id", "my-focus-this-week-container"], [1, "row", "mx-0", "mb-3"], [1, "col-10"], ["class", "d-inline-block", 3, "jhiTranslate", 4, "ngIf"], [1, "ml-2", "mr-2", "btn", "btn-link", 2, "position", "absolute", 3, "disabled", "click"], [1, "angle-icon", 2, "height", "18px", "width", "17px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#share"], [1, "col-2"], [3, "click"], [1, "angle-icon", 2, "height", "1rem"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-down", 4, "ngIf"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-up", 4, "ngIf"], ["class", "form-group mb-3", 4, "ngFor", "ngForOf"], ["class", "pl-3", 3, "d-none", 4, "ngIf"], [1, "row"], [2, "margin", "10px 0 20px 0", "width", "95%"], ["confirmDeleteModal", ""], [1, "d-inline-block", 3, "jhiTranslate"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-down"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-up"], [1, "form-group", "mb-3"], [1, "row", "no-gutters"], ["class", "form-check", 4, "ngIf"], [1, "col-9", "pr-2"], ["type", "text", "inputAutoDirectionSwitch", "", 1, "form-control", 2, "border", "1px solid #E1E1E1", "border-radius", "10px", 3, "disabled", "maxlength", "ngModel", "ngStyle", "ngModelChange", "blur"], ["textArea", ""], [1, "float-right"], [3, "ngClass"], ["class", "col-1 position-relative", 4, "ngIf"], [1, "form-check"], [3, "disabled", "checked", "ngModel", "ngModelChange", "change", "mousedown", "mouseup"], [1, "col-1", "position-relative"], ["data-id", "73", 1, "my-focus-this-week-group", "btn", "btn-link", 2, "position", "absolute", "top", "0", 3, "disabled", "click"], [2, "height", "15px", "width", "14px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#trash-bin"], [1, "pl-3"], [1, "btn", "btn-link", 3, "disabled", "click"], [4, "ngIf"], [1, "modal-header"], ["jhiTranslate", "entity.delete.title", 1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-hidden", "true", 1, "close", 3, "click"], [1, "modal-body"], ["id", "jhi-delete-organizationCode-heading", "jhiTranslate", "sessionChat.paragraph.deleteAction"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"], ["icon", "ban"], ["jhiTranslate", "sessionChat.word.no"], ["type", "submit", 1, "btn", "btn-danger", 3, "click"], ["icon", "times"], ["jhiTranslate", "sessionChat.paragraph.yes"], [1, "modal-title"], ["icon", "check"]], template: function ActionPlanFormPartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, ActionPlanFormPartComponent_h5_3_Template, 1, 1, "h5", 3);
        i0.ɵɵelementStart(4, "button", 4);
        i0.ɵɵlistener("click", function ActionPlanFormPartComponent_Template_button_click_4_listener() { return ctx.sharePlan(ctx.actionPlanItems, ctx.actionPlanGroup); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(5, "svg", 5);
        i0.ɵɵelement(6, "use", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelementStart(8, "a", 8);
        i0.ɵɵlistener("click", function ActionPlanFormPartComponent_Template_a_click_8_listener() { return ctx.toggleCollapse(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(9, "svg", 9);
        i0.ɵɵtemplate(10, ActionPlanFormPartComponent__svg_use_10_Template, 1, 0, "use", 10);
        i0.ɵɵtemplate(11, ActionPlanFormPartComponent__svg_use_11_Template, 1, 0, "use", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(12, "div");
        i0.ɵɵtemplate(13, ActionPlanFormPartComponent_div_13_Template, 11, 11, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, ActionPlanFormPartComponent_div_14_Template, 3, 3, "div", 13);
        i0.ɵɵelementStart(15, "div", 14);
        i0.ɵɵelement(16, "hr", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, ActionPlanFormPartComponent_ng_template_17_Template, 2, 2, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.headerKey);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabled);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.collapsed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.collapsed);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("d-none", ctx.collapsed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.actionPlanItems);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.multipleItemsAllowed());
    } }, directives: [i7.NgIf, i7.NgForOf, i8.JhiTranslateDirective, i9.DefaultValueAccessor, i10.InputAutoDirectionSwitchDirective, i9.MaxLengthValidator, i9.NgControlStatus, i9.NgModel, i7.NgStyle, i7.NgClass, i11.MatCheckbox, i12.AlertErrorComponent, i13.FaIconComponent], pipes: [i3.TranslatePipe], styles: [""] });
